import { type IntegrationSettingsActiveCampaignCheckboxes } from 'entities/Integrations'

export const ACTIVE_CAMPAIGN_SYNC_CHECKBOX_KEYS: IntegrationSettingsActiveCampaignCheckboxes[] = [
  'update_contacts',
  'create_non_existing_contacts',
]
